import { action, observable } from 'mobx'
import { observer } from 'mobx-react'
import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Button from '../../components/Button'
import Input from '../../components/Input'
import Modal from '../../components/Modal'
import Row from '../../components/Row'
import Select from '../../components/Select'
import request from '../../utils/request'

@observer
class AddPatientModal extends Component {
  @observable loading = false
  @observable error = false

  @observable
  fields = {
    name: '',
    gender: '',
    doctor: '',
    doctorGender: '',
    ethnicity: '',
    diagnosis: '',
  }

  @action
  setField = event => {
    this.error = false
    this.fields[event.target.name] = event.target.value
  }

  @action
  setLoading = () => {
    this.loading = true
    this.error = false
  }

  @action
  setError = () => {
    this.loading = false
    this.error = true
  }

  submit = async event => {
    const { history } = this.props
    event.preventDefault()

    if (this.loading) {
      return
    }

    this.setLoading()
    const res = await request('/api/patient/create', this.fields)

    if (res.success) {
      history.push(`/edit-patient/${res.data.patientID}`)
    } else {
      this.setError()
    }
  }

  render() {
    const { toggleAddPatient } = this.props

    return (
      <Modal title="titles.addNewPatient" onClose={toggleAddPatient}>
        {this.error && <Modal.ErrorMessage />}
        <form onSubmit={this.submit}>
          <Modal.Pad>
            <Row>
              <Row.Cell flex="2">
                <Input
                  disabled={this.loading}
                  label="titles.patientName"
                  name="name"
                  value={this.fields.name}
                  onChange={this.setField}
                />
              </Row.Cell>
              <Row.Cell>
                <Select
                  disabled={this.loading}
                  label="titles.gender"
                  name="gender"
                  value={this.fields.gender}
                  onChange={this.setField}
                  allowBlank
                >
                  <Select.Options choices="gender" />
                </Select>
              </Row.Cell>
            </Row>
            <Row>
              <Row.Cell>
                <Select
                  disabled={this.loading}
                  label="titles.ethnicity"
                  name="ethnicity"
                  value={this.fields.ethnicity}
                  onChange={this.setField}
                  allowBlank
                >
                  <Select.Options choices="ethnicity" />
                </Select>
              </Row.Cell>
              <Row.Cell>
                <Select
                  disabled={this.loading}
                  label="titles.diagnosis"
                  name="diagnosis"
                  value={this.fields.diagnosis}
                  onChange={this.setField}
                  allowBlank
                >
                  <Select.Options choices="diagnosis" />
                </Select>
              </Row.Cell>
            </Row>
            <Row>
              <Row.Cell flex="2">
                <Input
                  disabled={this.loading}
                  label="titles.doctor"
                  name="doctor"
                  value={this.fields.doctor}
                  onChange={this.setField}
                />
              </Row.Cell>
              <Row.Cell>
                <Select
                  disabled={this.loading}
                  label="titles.gender"
                  name="doctorGender"
                  value={this.fields.doctorGender}
                  onChange={this.setField}
                  allowBlank
                >
                  <Select.Options choices="gender" />
                </Select>
              </Row.Cell>
            </Row>
          </Modal.Pad>
          <Modal.Divider />
          <Modal.Pad>
            <Button
              color="blue"
              str="titles.createPatient"
              type="submit"
            />
          </Modal.Pad>
        </form>
      </Modal>
    )
  }
}

export default withRouter(AddPatientModal)



// WEBPACK FOOTER //
// ./src/pages/Patients/AddPatientModal.js